import { render, staticRenderFns } from "./bindAlipay.vue?vue&type=template&id=36aafd0d&scoped=true&"
import script from "./bindAlipay.vue?vue&type=script&lang=js&"
export * from "./bindAlipay.vue?vue&type=script&lang=js&"
import style0 from "./bindAlipay.vue?vue&type=style&index=0&id=36aafd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aafd0d",
  null
  
)

export default component.exports